import { render, staticRenderFns } from "./10.vue?vue&type=template&id=c377b006&scoped=true&"
var script = {}
import style0 from "./10.vue?vue&type=style&index=0&id=c377b006&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c377b006",
  null
  
)

export default component.exports